import React, { useEffect, useState } from "react";
import "./Categories.scss";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { CiSearch } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { fetchCategoriesListApi } from "../../../services/common";
import useDebounce from "../../../hooks/useDebounce";
import { encryptData } from "../../../utils/dataCipher";
import NotFoundPlaceHolder from "../../../components/not-found/NotFoundPlaceHolder";
import FlatList from "components/FlatList";
import Skeleton from "react-loading-skeleton";

const Categories = () => {
  const navigate = useNavigate();
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  // console.log('categoryList', categoryList)
  //   Fetching Category List
  const fetchCategoryList = async () => {
    try {
      setLoading(true);
      const { data } = await fetchCategoriesListApi({ search: debouncedValue });
      const { success, data: response } = data;
      if (success) {
        setCategoryList(response);
      } else {
        setCategoryList([]);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryList();
  }, [debouncedValue]);

  // Recursive function to render nested lists
  const renderList = (items) => {
    return (
      <ul>
        {items?.map((item, index) => (
          <li key={index}>{Array.isArray(item) ? renderList(item) : item}</li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <DashboardHeader title={"Overview"} />
      <div className="dashboard_pages">
      <div className="categories_parent">
        <div className="search_bar">
          <input
            type="text"
            className="search_input"
            placeholder="Search here"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <CiSearch className="search_icon" />
        </div>

        <div className="categories_list_types">
          <FlatList
            data={categoryList}
            renderItem={(data) => {
              return (
                <div key={data._id} className="technologies_list">
                  <Link
                    to={`/dashboard/category/group-list?info=${encryptData(
                      data
                    )}`}
                  >
                    <img src={data?.image} alt="" />
                    <span className="tech_list_name">{data?.name}</span>
                  </Link>
                </div>
              );
            }}
            loading={loading}
            numLoading={8}
            loadingItem={(it) => {
              return (
                <div key={it} className="technologies_list loading">
                  <div className="link">
                    <Skeleton
                      circle
                      className="image"
                      containerClassName="image"
                    />
                    <span className="tech_list_name w-100">
                      <Skeleton className="w-100" containerClassName="w-100" />
                    </span>
                  </div>
                </div>
              );
            }}
            placeholder={
              <NotFoundPlaceHolder title="No Categories available" />
            }
          />
        </div>
      </div>
      </div>
    </>
  );
};

export default Categories;
